import { environment } from 'src/environments/environment';
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ModulePermission } from '../models/module-permission.model';

@Injectable({
    providedIn: 'root'
})
export class UserProfileService {
    constructor(private http: HttpClient) {}

    getAllProfile() {
        return this.http.get<any>( `${environment.appOrgUrl}UserProfile`);
    }

    saveProfile(profileData){
        return this.http.post<any>( `${environment.appOrgUrl}UserProfile`, profileData);
    }

    updateProfile(profileData){
        return this.http.put<any>( `${environment.appOrgUrl}UserProfile`, profileData);
    }

    transferRole(transferRoleData){
        return this.http.post<any>( `${environment.appOrgUrl}Role/TransferRole`, transferRoleData);
    }

    deleteRole(roleHierarchyId: number){
        return this.http.delete<any>( `${environment.appOrgUrl}Role/Roles/${roleHierarchyId}`);
    }

    getAssociatedUsers(profileId: number){
        return this.http.get<any>( `${environment.appOrgUrl}User/AllProfileUsers/${profileId}`);
    }

    deleteAndTransferProfile(idforDelete: number, idforTransfer: number){
        return this.http.delete<any>( `${environment.appOrgUrl}UserProfile/${idforDelete}/${idforTransfer}`);
    }

    getProfilesModulePermission(profileId: number){
        return this.http.get<any>( `${environment.appOrgUrl}UserProfilePermission/ProfileModulePermission/${profileId}`);
    }

    addProfilePermission(permissionData: ModulePermission[]){
        return this.http.post<any>( `${environment.appOrgUrl}UserProfilePermission/Permissions`, permissionData);
    }

    getReportsPermission(profileId: number){
        return this.http.get<any>( `${environment.appOrgUrl}UserProfilePermission/ProfileReportPermission/${profileId}`);
    }

    getSystemDefaultChannel(){
        return this.http.get<any>( `${environment.appOrgUrl}UserProfile/DefaultChannelProfile`);
    }
}
